import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Network, LinkIcon, Settings, LogOut, Menu, X, Sparkles, Target, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/lib/AuthContext";

const LINKS = [
  { to: "/agent", icon: LayoutDashboard, label: "Panoramica", testid: "nav-overview", end: true },
  { to: "/agent/leads", icon: Users, label: "Lead", testid: "nav-leads" },
  { to: "/agent/network", icon: Network, label: "Rete Agenti", testid: "nav-network" },
  { to: "/agent/link", icon: LinkIcon, label: "Marketing & Lead", testid: "nav-link" },
  { to: "/agent/social-coach", icon: Sparkles, label: "Social Coach", testid: "nav-social-coach" },
  { to: "/agent/strategy-coach", icon: Target, label: "Strategy Coach", testid: "nav-strategy-coach" },
  { to: "/agent/sara", icon: MessageCircle, label: "Sara", testid: "nav-sara" },
  { to: "/agent/settings", icon: Settings, label: "Impostazioni", testid: "nav-settings" },
];

export default function AgentLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user) nav("/login");
  }, [user, nav]);

  if (!user) return null;

  const sidebar = (
    <aside className="vg-sidebar w-64 h-screen sticky top-0 overflow-y-auto p-5 flex flex-col" data-testid="agent-sidebar">
      <div className="mb-8 px-2"><Logo size={22} white /></div>
      <nav className="space-y-1 flex-1">
        {LINKS.map((l) => (
          <NavLink
            key={l.to} to={l.to} end={l.end}
            onClick={() => setOpen(false)}
            data-testid={l.testid}
            className={({ isActive }) => `vg-sidebar-link ${isActive ? "active" : ""}`}
          >
            <l.icon size={18} /> {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="border-t border-white/10 pt-4 mt-4">
        <div className="px-3 mb-3">
          <p className="text-sm font-semibold text-white truncate">{user.nome} {user.cognome}</p>
          <p className="text-xs text-gray-400 truncate">{user.email}</p>
          {user.ruolo === "fpa" && <span className="inline-block text-[10px] font-bold mt-1 px-2 py-0.5 rounded-full" style={{ background: "#B40101" }}>FPA</span>}
        </div>
        <button onClick={() => { logout(); nav("/login"); }} className="vg-sidebar-link w-full" data-testid="agent-logout">
          <LogOut size={18} /> Esci
        </button>
      </div>
    </aside>
  );

  return (
    <div className="min-h-screen" style={{ background: "#F5F5F5" }}>
      <div className="md:hidden flex items-center justify-between bg-[#404040] text-white p-4">
        <Logo size={20} white />
        <button onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      <div className="flex">
        <div className="hidden md:block">{sidebar}</div>
        {open && (
          <div className="fixed inset-0 z-40 md:hidden">
            <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
            <div className="relative">{sidebar}</div>
          </div>
        )}
        <main className="flex-1 p-4 sm:p-8 max-w-full overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
